import type { AssetType } from '@repo/types/asset';

import { getAppConfig } from '@/utils/window.utils';

const isEnabledFor = (assetType: AssetType | undefined, enableFor: AssetType[] | undefined): boolean =>
    Boolean(assetType && enableFor?.includes(assetType));

export const isAttachmentAddEnabled = (assetType: AssetType | undefined): boolean => {
    const config = getAppConfig();
    return isEnabledFor(assetType, config.feature.attachments?.add?.enableFor);
};

interface AttachmentFeatures {
    isAddEnabled: boolean;
    isEditEnabled: boolean;
    isRemoveEnabled: boolean;
    isCommentEnabled: boolean;
}

export const getAttachmentFeatures = (assetType: AssetType | undefined): AttachmentFeatures => {
    const attachments = getAppConfig().feature.attachments;
    const isAddEnabled = isEnabledFor(assetType, attachments?.add?.enableFor);
    const isEditEnabled = isEnabledFor(assetType, attachments?.edit?.enableFor);
    const isRemoveEnabled = isEditEnabled && isEnabledFor(assetType, attachments?.remove?.enableFor);
    const isCommentEnabled = isEditEnabled && isEnabledFor(assetType, attachments?.editComments?.enableFor);
    return { isAddEnabled, isEditEnabled, isRemoveEnabled, isCommentEnabled };
};
